/*
 * Copyright (c) 2026 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.common.crossplatform

import kotlin.reflect.KClass
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

// The types of the platforms without reflection, and the dates of the data frames read by molap

@OptIn(ExperimentalTime::class)
internal fun isInstantType(cl: KClass<*>): Boolean = cl == Instant::class

@OptIn(ExperimentalTime::class)
internal fun isInstant(value: Any?): Boolean = value is Instant

/** The milliseconds since the epoch of an [Instant], or NaN. */
@OptIn(ExperimentalTime::class)
internal fun instantMillis(value: Any?): Double = (value as? Instant)?.toEpochMilliseconds()?.toDouble() ?: Double.NaN

/** Whether [b] is [a], or a subclass of [a] that can be told without reflection: anything for Any, the numbers for Number. */
internal fun isAssignableWithoutReflection(a: KClass<*>, b: KClass<*>): Boolean = a == b || a == Any::class ||
    a == Number::class && (b == Int::class || b == Long::class || b == Double::class || b == Float::class || b == Short::class || b == Byte::class)
